/**
 * OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPage
 *
 * Page component for OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPage
 * Path: /docs/reference/operators/validate
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsValidateENDocScreenView as __OrbDocReferenceOperatorsValidateENDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsValidateENDocScreenView';
import { OrbDocReferenceOperatorsValidateENDocAnalyticsView as __OrbDocReferenceOperatorsValidateENDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsValidateENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPage(_props: OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Validation","description":"Every operator a .lolo program can call, from the canonical registry the compiler bakes.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators/validate"},{"locale":"ar","path":"/ar/docs/reference/operators/validate"},{"locale":"sl","path":"/sl/docs/reference/operators/validate"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsValidateENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsValidateENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsValidateENOrbDocReferenceOperatorsValidateENPage;
